/**
 * hellopanda-sticky
 */
import Sticky from './sticky';
const HELLOPANDA_STICKY = {
  debounce: function(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  },
  setMinHeight: function(stickyBlocks) {
    stickyBlocks.forEach(stickyBlock => {
      let beforeHeight = 0;
      const innerDom = stickyBlock.querySelector(' & > .wp-block-template-part');
      const targetDom = innerDom ? innerDom : stickyBlock ;
      const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          if (beforeHeight != entry.contentRect.height) {
            beforeHeight = entry.contentRect.height;
            const cover = stickyBlock.closest('.wp-block-hellopanda-sticky-block');
            if (cover) {
              cover.style.minHeight = innerDom ? innerDom.offsetHeight + 'px' : stickyBlock.offsetHeight + 'px' ;
              console.log(cover, cover.style.minHeight);
            }
          }
        });
      });
      resizeObserver.observe(targetDom);
    });
  },
  init: function() {

    // let Sticky;
    // try {
    //   Sticky = require('sticky-js');
    // } catch (error) {
    //   console.warn("Sticky-js module not found, the Sticky-js effect is disabled.");
    // }

    const _ = this;
    
    if (typeof Sticky === 'function') {

      // 제어할 객체가 있을때만 실행
      const stickyBlocks = document.querySelectorAll('.wp-block-hellopanda-sticky-item-block');
      if (!stickyBlocks.length) {
        return;
      }

      window.hellopanda = window.hellopanda || {} ;
      window.hellopanda.library = window.hellopanda.library || {} ;
      window.hellopanda.library.sticky = new Sticky('.wp-block-hellopanda-sticky-item-block');

      // 윈도우 리사이즈 시 스티키 업데이트, debounce로 콜을 지연시킴
      const debouncedUpdate = this.debounce(function() {
        window.hellopanda.library.sticky.update();
      }, 30); // 200ms 딜레이

      window.addEventListener('resize', debouncedUpdate);
      window.addEventListener("scroll", (event) => {
        debouncedUpdate();
      });
      window.addEventListener("load", (event) => {
        debouncedUpdate();
      });

      // 높이 미리 체크
      // _.setMinHeight(stickyBlocks);
    }

  }
};
HELLOPANDA_STICKY.init();